interface FormItemDisplayProps {
  value?: string;
}

const FormItemDisplay: React.FC<FormItemDisplayProps> = ({ value }) => {
  return <span>{value}</span>;
};

export default FormItemDisplay;
